export default __webpack_public_path__ + "static/media/video.0f025f92.svg";